import { render, staticRenderFns } from "./UpcomingElections.vue?vue&type=template&id=6174f92e"
import script from "./UpcomingElections.vue?vue&type=script&lang=js"
export * from "./UpcomingElections.vue?vue&type=script&lang=js"
import style0 from "./UpcomingElections.vue?vue&type=style&index=0&id=6174f92e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports